export default "__VITE_ASSET__DwG5k5RV__"